module.exports = __webpack_public_path__ + "img/block-375.83e54849.jpg";